<template>
  <div>
    <div style="margin-bottom: 10px; margin-top: 10px">
      <el-button type="primary" @click="showBox" style="color: #FFFFFF">新增</el-button>
      <el-button type="warning" @click="importData()" style="color: #FFFFFF">导入</el-button>
      <el-button @click="search()">查询</el-button>
    </div>

    <div>
      <el-descriptions :column="4" border size="mini">
        <el-descriptions-item label="所在项目">
          <el-input size="mini" placeholder="" v-model="params.project_name" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="姓名">
          <el-input size="mini" placeholder="请输入姓名" v-model="params.user_name" clearable></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>


    <div style="margin-top: 10px;">
<!--      <span style="color:red">加载中...</span>-->
    </div>
    <el-table ref="Table" v-if="list" :data="list" height="680px">
      <el-table-column prop="project" label="项目" align="center"></el-table-column>
      <el-table-column prop="name"label="姓名" align="center"></el-table-column>
      <el-table-column prop="phone_number"label="手机" align="center"></el-table-column>
      <el-table-column label="权限" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.role == 1">主管</span>
          <span v-if="scope.row.role == 2">经理</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" style="color: #FFFFFF" @click="del(scope.row.role_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="total, prev, pager, next, jumper, sizes"  class="pagination"
                   :total="params.total"
                   :current-page="params.page"
                   :page-size="params.pageSize"
                   :page-sizes="[50, 100, 500]"
                   @current-change="handleCurrentChange" @size-change="handleSizeChange"/>

    <el-dialog title="新增" z-index="990" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">
      <div style="max-height: 700px;overflow-y: auto;">
        <el-descriptions class="margin-top" title="" :column="1" size="mini" border>
          <el-descriptions-item label="项目">
            <div>
              <el-autocomplete
                style="width: 100%"
                v-model="formData.project"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入项目"
                @select="handleSelect"
              ></el-autocomplete>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="员工">
            <el-select v-model="formData.user_id" placeholder="请选择">
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.name + '(' + item.phone_number + ')'"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="角色">
            <el-radio v-model="formData.role" :label="1">主管</el-radio>
            <el-radio v-model="formData.role" :label="2">经理</el-radio>
          </el-descriptions-item>

        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
        <el-button size="mini" @click="saveForm()">确认</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import Http from "../common/Http";

export default {
  name: 'RoleList',
  data() {
    return {
      params: {
        project_name: "",
        user_name: "",
        total: 0,
        page: 1,
        pageSize: 20
      },
      list: [],
      projectList: [],
      userList: [],
      dialogVisible: false,
      formData: {
        project : "",
        project_id : "",
        role : 1,
        user_id : "",
      }
    }
  },
  //界面没出来前加载
  created() {

  },
  mounted() {
    let date = new Date();
    let month = date.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    this.params.month = date.getFullYear() + '-' + month;
    this.getList()
    this.getProjectList()
  },
  methods: {

    search() {
      this.params.page = 1;
      this.getList()
    },
    showBox() {
      this.dialogVisible = true
    },
    saveForm() {
      let that = this
      let params = this.formData
      Http.post(Http.getPreBaseURL() + "/oa/user/addUserRole", params, res => {
        if (res.code == 0) {
          that.getList()
          that.dialogVisible = false
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    getList() {
      let params = this.params
      Http.get(Http.getPreBaseURL() + '/oa/user/getUserRoleList', params, res => {
        if (res.code === 0) {
          this.list = res.data.data;
          this.params.page = res.data.current_page;
          this.params.pageSize = res.data.per_page;
          this.params.total = res.data.total;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    del(id) {
      let params = {id : id};
      Http.get(Http.getPreBaseURL() + '/oa/user/delUserRole', params, res => {
        if (res.code === 0) {
          this.$message.success({
            message: res.msg,
            type: "success",
          })
          this.getList()
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.params.pageSize = val
      this.getList()
    },
    getProjectList() {
      let that = this
      Http.get(Http.getPreBaseURL() + '/oa/user/projectList', {}, res => {
        if (res.code === 0) {
          that.projectList = res.data
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    getUserList() {
      let that = this
      if (that.formData.project_id !== "") {
        let params = {
          'pageSize' : 10000,
          'project_id' : that.formData.project_id,
        }
        Http.get(Http.getPreBaseURL() + '/oa/user/getUserInfoAllList', params, res => {
          if (res.code === 0) {
            that.userList = res.data.data
          } else {
            this.$message.error({
              message: res.msg,
              type: "error",
            })
          }
        })
      } else {
        that.userList = []
      }
    },
    querySearchAsync(queryString, cb) {
      this.formData.project_id = 0
      this.userList = []
      let projectList = this.projectList;
      let results = queryString ? projectList.filter(this.createStateFilter(queryString)) : projectList;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.department_name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.formData.project_id = item.id
      this.getUserList()
    },
    importData() {
      var that = this;
      let upload = document.getElementById("uploadFile-9999");
      if (!upload) {
        upload = document.createElement('input');
        upload.type = "file";
        upload.id = "uploadFile-9999";
        upload.style.display = "none";
      }
      upload.click();
      upload.onchange = function (e) {

        let formData = new FormData();
        formData.append("user_file", this.files[0]);
        Http.post(Http.getPreBaseURL() + '/oa/User/importRole', formData, res => {
          that.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
        })
        upload.onchange = undefined;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$widths: 100px;
.month-table {
  border-color: gray;
  border-collapse: separate;
  user-select: none;
  font-size: 12px;
  min-width: 1200px;
  min-height: 100px;

  tr:hover {
    td.fixed {
      background-color: #dddddd;
      border: 1px solid #ebeef5;
      color: #000;
    }
  }

  th, td {
    min-width: 24px;
    padding: 5px 0px;

    &.fixed {
      position: sticky;
      cursor: pointer;
      z-index: 2;
    }
  }

  th {
    background: #f5f7fa;
    color: #909399;
    border: 1px solid #ebeef5;

    &.hover {
      background-color: #ffebbe;
      color: #333;
    }
  }

  td {
    color: #606266;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
    text-align: center;
    overflow: hidden;

    &:first-child {
      border-left: 1px solid #ebeef5;
    }

    &.day-item {
      &.check {
        //background: #fafafa;
        opacity: .5;
      }

      &.changed {
        background: #fd9dca;
        color: #333;
      }

      &.selected {
        background: #409eff;
        color: #409eff;
      }
    }

    &.fixed {
      background-color: #fafafa;
    }

    .work-class-label {
      display: inline-block;
    }
  }

  .department-name {
    box-sizing: border-box;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 78px;
    padding: 0 3px;
    line-height: 20px;
  }

  &.show-department {
    .department-name {
      text-overflow: unset;
      overflow: visible;
      white-space: normal;
      width: 198px;
    }
  }

  .inp {
    box-sizing: border-box;
    width: 100%;
    min-width: 50px;
    text-align: center;
    border: 1px solid #fff;
    outline: none;
    font-size: 12px;
    border-radius: 3px;

    &:hover, &:focus {
      border-color: #ccc;
    }
  }

  .w80 {
    display: inline-block;
    width: 79px;
  }

}

.day-head {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/PreUser/RoleList.vue